import './scss/theme-view.scss';
import '@splidejs/splide/css';

// https://github.com/WordPress/block-theme-examples/blob/master/example-build-process/functions.php
// https://developer.wordpress.org/news/2023/07/19/beyond-block-styles-part-1-using-the-wordpress-scripts-package-with-themes/
// https://developer.wordpress.org/news/2023/07/27/beyond-block-styles-part-2-building-a-custom-style-for-the-separator-block/
// https://developer.wordpress.org/news/2023/08/04/beyond-block-styles-part-3-building-custom-design-tools/

// block wp query
// https://ryanwelcher.com/2021/08/18/requesting-data-in-gutenberg-with-getentityrecords/

import domReady from './js/dom-ready.js';
import elmntIO from './js/elmnt-io.js';
import { boilerplateNavMain } from './js/nav-main.js';
import { testimonialSlider } from './js/slider.js';


domReady( function () {
    //do something after DOM loads.
    // console.log('theme-view.js', 'hello');

    // ===== elmntIo catch-all =====
    const $elsHaveIO = document.querySelectorAll('[data-io]:not(.io-ignore)');
    $elsHaveIO?.forEach($el => elmntIO($el));

    // ===== other =====
    boilerplateNavMain();
    testimonialSlider();
} );